/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserUpdateResponse {
    getFixupPrototypeFunction() { return UserUpdateResponse.fixupPrototype; }

    static newInstance(model: Partial<UserUpdateResponse>): UserUpdateResponse {
        let obj = Object.assign(new UserUpdateResponse(), model);
        UserUpdateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserUpdateResponse>): UserUpdateResponse {
        if (!model) return null;
        return UserUpdateResponse.newInstance(<UserUpdateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserUpdateResponse) {
        if (!obj) return;

        models.UserUpdateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserUpdateResponse): boolean {
        Object.setPrototypeOf(obj, UserUpdateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the updated User
     */
    user_id: string;

}
